module.exports = __webpack_public_path__ + "static/media/how-it-works-large.3bafc016.jpg";